import { render, staticRenderFns } from "./systemTerms.vue?vue&type=template&id=7180832a&scoped=true&"
import script from "./systemTerms.vue?vue&type=script&lang=js&"
export * from "./systemTerms.vue?vue&type=script&lang=js&"
import style0 from "./systemTerms.vue?vue&type=style&index=0&id=7180832a&lang=scss&scoped=true&"
import style1 from "./systemTerms.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7180832a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VIcon,VLayout})
